module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/funabashi_ekimae_point1-c2e507bb91b39ae3aa45cac9b08b9979.jpg";